import React, { useEffect } from 'react'
import Modal from 'react-bootstrap/Modal'
import { useTranslation } from 'react-i18next'
import { Image } from 'react-bootstrap'
import 'common/styling/modal-styling.scss'
import '../Modal.scss'
import appConfig from 'app.config'
import { useLogoHelper } from 'utils/logoHelper'

interface IIdleTimeOut {
	showModal: boolean
	handleClose: any
	handleLogout: any
	remainingTime: number
}

interface ITime {
	seconds: number
	minutes: number
}

export const IdleTimeOutModal = ({
	showModal,
	handleClose,
	handleLogout,
	remainingTime,
}: IIdleTimeOut) => {
	const { t } = useTranslation()
	const { blackLogo } = useLogoHelper()
	const [time, setTime] = React.useState<ITime>({
		seconds: remainingTime,
		minutes: 0,
	})

	useEffect(() => {
		const interval = setInterval(() => {
			if (showModal) {
				if (time.seconds % 2) {
					document.title = t('IdleTimeout')
				} else {
					document.title = t('Title', {
						company: appConfig.companyName,
					})
				}
				if (time.seconds > 0) {
					setTime((prev) => ({
						...prev,
						seconds: time.seconds - 1,
					}))
				} else {
					handleLogout()
				}
			}
		}, 1000)
		return () => clearInterval(interval)
	})

	function clearCounterAndHandleClose() {
		setTime((prev) => ({
			...prev,
			seconds: remainingTime,
		}))
		document.title = t('Title', { company: appConfig.companyName })
		handleClose()
	}

	return (
		<Modal
			show={showModal}
			onHide={clearCounterAndHandleClose}
			animation={false}
			centered
			className="idletimeout-modal"
			backdrop="static">
			<Modal.Header closeButton>
				<div>
					<Image
						src={blackLogo}
						className="logo"
						alt="logo"
					/>
				</div>
			</Modal.Header>
			<Modal.Body>
				<div>{t('LogoutWarning', { time })}</div>
				<div className="loading-container">
					<div className="loading"></div>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<button
					id="idle-timeout-logout-button"
					type="button"
					className="btn btn-outline-darkgray"
					onClick={handleLogout}>
					{t('Logout')}
				</button>
				<button
					id="idle-timeout-reactivate-button"
					type="button"
					className="btn btn-primary"
					onClick={() => {
						setTimeout(() => {
							clearCounterAndHandleClose()
						}, 400)
					}}>
					{t('Reactivate')}
				</button>
			</Modal.Footer>
		</Modal>
	)
}